export const LANDING_SECTION = {
  SPLASH: "Splash",
  ADVANTAGES: "Advantages",
  ABOUT: "About",
  AUTHOR: "Author",
  STATEMENTS: "Statements",
  CONTENTS: "Contents",
  FAQ: "FAQ",
};

export const LANDING_EXPANDABLE = {
  ABOUT: "about-text",
  AUTHOR: "author-text",
};

export const BIG_LANDING_LINKS = [
  {
    href: "/read/132.2",
    label: "Read",
    id: "openReaderHeadMenuButton",
  },
  {
    href: "/#" + LANDING_SECTION.ADVANTAGES,
    label: "Advantages",
    id: "openAdvantagesHeadMenuButton",
  },
  {
    href: "/#" + LANDING_SECTION.ABOUT,
    label: "About",
    id: "openAboutHeadMenuButton",
  },
  {
    href: "/#" + LANDING_SECTION.STATEMENTS,
    label: "Statements",
    id: "openStatementsHeadMenuButton",
  },
  {
    href: "/#" + LANDING_SECTION.CONTENTS,
    label: "Contents",
    id: "openContentsHeadMenuButton",
  },
  {
    href: "/#" + LANDING_SECTION.FAQ,
    label: "FAQ",
    id: "openFAQHeadMenuButton",
  },
  {
    href: "/#" + LANDING_SECTION.AUTHOR,
    label: "The Author",
    id: "openAuthorHeadMenuButton",
  },
];

export const LANDING_FAQ = [
  {
    id: "01",
    title: `What is "The Great Controversy" about?`,
    message: `"The Great Controversy" is the last volume in the 'Conflict of the Ages' series that provides an exploration of the ongoing spiritual battle between God and Satan. It covers periods from the fall of Jerusalem to the end times, providing a historical, spiritual, and prophetic context that allows readers better to understand the biblical narrative and their role in it.`,
  },
  {
    id: "02",
    title: `Is "The Great Controversy" just for Christians?`,
    message: `While the book uses a Christian framework, its exploration of the cosmic conflict, historical events, and their spiritual implications can enlighten anyone interested in spirituality, history, or the bigger questions of life and existence.`,
  },
  {
    id: "03",
    title: `Why is "The Great Controversy" relevant to my life today?`,
    message: `"The Great Controversy" is not just about past events. It offers a perspective on the challenges and spiritual struggles we face daily. Understanding the 'bigger picture' can help you navigate these challenges with wisdom and resilience.
    `,
  },
  {
    id: "04",
    title: `I've heard "The Great Controversy" is a difficult read. Is that true?`,
    message: `The book does delve into complex issues of faith, history, and spirituality, but it's written in a way that's intended to be accessible and engaging to all readers, regardless of their background.`,
  },
  {
    id: "05",
    title: `Will "The Great Controversy" conflict with my current beliefs?`,
    message: `"The Great Controversy" is a resource that aims to enlighten and inform. While it might challenge some preconceptions, its primary goal is to enrich your understanding of the spiritual realm, not to discredit or override personal beliefs.`,
  },
  {
    id: "06",
    title: `Is this book biased towards a particular Christian denomination?`,
    message: `While the book does have its roots in Seventh-day Adventist thought, its coverage of the great cosmic conflict is relevant to Christians of all denominations. The historical events and concepts explored are universal within Christianity.
    `,
  },
  {
    id: "07",
    title: `Why should I read "The Great Controversy" aside from other Christian literature?`,
    message: `"The Great Controversy" provides a unique perspective on the spiritual battle between good and evil, examining this conflict's history and future implications. It offers insights that can enrich your understanding of your faith and spiritual journey.
    `,
  },
];

export const LANDING_STATEMENTS = [
  {
    id: "01",
    message: `It is the restraining power of God that prevents mankind from passing fully
    under the control of Satan.`,
    ref: "p. 36",
  },
  {
    id: "02",
    message: `Christianity is a system, which, received and obeyed, would spread peace,
    harmony, and happiness throughout the earth.`,
    ref: "p. 46",
  },
  {
    id: "03",
    message: `In our time there is a wide departure from their doctrines and precepts, and
    there is need of a return to the great Protestant principle—the Bible, and the
    Bible only, as the rule of faith and duty.`,
    ref: "p. 204",
  },
  {
    id: "04",
    message: `We should choose the right because it is right, and leave consequences with God.`,
    ref: "p. 460",
  },
  {
    id: "05",
    message: `The Christian's life should be one of faith, of victory, and joy in God.`,
    ref: "p. 477",
  },
  {
    id: "06",
    message: `The great controversy is ended. Sin and sinners are no more. The entire universe is clean... From
    the minutest atom to the greatest world, all things, animate and inanimate, in their unshadowed
    beauty and perfect joy, declare that God is love.`,
    ref: "p. 678",
  },
];
